 export const skillsData = [
   "HTML",
   "CSS",
   "tailwindCss",
   "vitejs",
   "Bootstrap",
   "Javascript",
   "React",
   "NodeJs",
   "express",
   "MongoDB",
   "MySql",
   "git",
   "github",
   "Documentation",
   "Postman",
   "Netlify"
 ];


